import { render } from "./Ordered.vue?vue&type=template&id=1a8dcb83&scoped=true"
import script from "./Ordered.vue?vue&type=script&lang=js"
export * from "./Ordered.vue?vue&type=script&lang=js"

import "./Ordered.vue?vue&type=style&index=0&id=1a8dcb83&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a8dcb83"

export default script